import { fromJS } from 'immutable';

import { ApiQualityRating,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading,GetQualityRating } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });
    const Authorization = UserToken;
    const orderBy = "DESC";
    
    const url = ApiQualityRating + 'quality-rating-list';
    if(page === undefined){
        page = 1;
    }

    var query = {
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":orderBy,
        "search":search,
    }
    var paramBody = {
        "query": query
    };

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');

        var data2 = {
            'row-count': data.get('row-count'),
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': data.get('order-by') ? data.get('order-by') : orderBy,
            'page': data.get('page'),
            'order': data.get('order'),
            'data': data.get('data')
        }
    }
    dispatch({ type: GetQualityRating, data: fromJS(data2) });
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus: response.ok });
};